import React,{ useEffect, useState } from 'react';
import {Page } from 'react-weui';
import { getCourseDetail } from '@/services/course';
import { postMemberShareLog } from '@/services/myself';
import Error from '@/components/Error';
import VideoDetail from './videoDetail';
import MusicDetail from './musicDetail';
import ArticleDetail from './articleDetail';
import { Toast } from 'antd-mobile';
import { updateShareInfo } from '@/utils/utils';



export default (props) => {

  const courseId = props.location.query.courseId;
  const memberId = props.location.query.shareMember;

  const [detail, setDetail] = useState(null);
  const [error, setError] = useState(null);



  useEffect(()=>{
    document.title = props.location.query.title;

    getDetail();
  },[]);

  useEffect(() => {
    if (memberId) {
      postMemberShareLog({
        courseId,
        shareMemberId: memberId,
      }).then(res => {
        if (res && res.code === 200) {
        } else {
          console.error(res);
        }
      });
    }
  }, [memberId]);


  function getDetail() {
    Toast.loading('loading',60);
    getCourseDetail({id: courseId}).then(res => {
      console.log(res);
      Toast.hide();
      if (res && res.code == 200) {
        document.title = res.data.name;
        setDetail(res.data);
        updateShareInfo({
          title: res.data.name,
          imgUrl: res.data.image,
        });
        setError(null);
      }else {
        setError(res.message);
      }

    }).catch(error => {
      setError('获取失败，请重试');
      Toast.hide()
    });
  }




  if (!detail) {
    return(
      <Page transition={true} infiniteLoader={false} ptr={false}>
      </Page>
    )
  }



  return(
    <Page transition={true} infiniteLoader={false} ptr={false}>

      {error ? <Error error={error} onRefresh={()=> {
        getDetail();
      }}/>
      : fillDetail()}

    </Page>
  )


  function fillDetail() {
    if (detail.type == '1') {
      return( <VideoDetail course={detail}/>);
    }else if (detail.type == '2') {
      return( <MusicDetail course={detail}/>);
    }else if (detail.type == '3') {
      return( <ArticleDetail course={detail}/>);
    } else {
      return;
    }


  }
}


